module.exports = __webpack_public_path__ + "img/Equinox2.173adedd.png";